import React, { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { ProductIntro } from './ProductIntro';
import { TomosList } from './TomosList';
import { Bonos } from './Bonos';
import { BeforeAfter } from './BeforeAfter';
import { Beginners } from './Beginners';
import { SummerCollection } from './SummerCollection';
import { ForWho } from './ForWho';
import { ValueStack } from './ValueStack';
import { Urgency } from './Urgency';
import { Pricing } from './Pricing';
const LateContent = lazy(() => import('./LateContent').then(({
  LateContent: Content
}) => ({
  default: Content
})));
interface DeferredContentProps {
  onCta: () => void;
  onReady: () => void;
}

/** Long-form sales content stays outside the critical rendering path. */
export function DeferredContent({
  onCta,
  onReady
}: DeferredContentProps) {
  const lateContentTriggerRef = useRef<HTMLDivElement>(null);
  const [shouldLoadLateContent, setShouldLoadLateContent] = useState(false);
  useEffect(() => {
    onReady();
  }, [onReady]);
  useEffect(() => {
    const trigger = lateContentTriggerRef.current;
    if (!trigger) return undefined;
    if (!('IntersectionObserver' in window)) {
      setShouldLoadLateContent(true);
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      setShouldLoadLateContent(true);
      observer.disconnect();
    }, {
      rootMargin: '420px 0px'
    });
    observer.observe(trigger);
    return () => observer.disconnect();
  }, []);
  return <>
      <ProductIntro data-id="element-40" data-mp="2r4ehb3ip4j0h" />
      <TomosList data-id="element-41" data-mp="2r70lct6dogdy" />
      <Bonos data-id="element-42" data-mp="3545oakasoz4z" />
      <BeforeAfter data-id="element-43" data-mp="354p8y8rty1mp" />
      <Beginners data-id="element-44" data-mp="3534esk9fgkpd" />
      <SummerCollection data-id="element-45" data-mp="353mig1yf617b" />
      <ForWho data-id="element-46" data-mp="312u8t7lmxuai" />
      <ValueStack data-id="element-47" data-mp="3133pu5opcr42" />
      <Urgency data-id="element-48" data-mp="312ke56pnayyh" />
      <div id="pricing" className="scroll-mt-4" data-id="element-49" data-mp="3145bf43cgw01">
        <Pricing data-id="element-50" data-mp="1aqela3mz1dii" />
      </div>
      <div ref={lateContentTriggerRef} className="h-px" aria-hidden="true" data-id="element-51" data-mp="1apmpostdjfs8" />
      {shouldLoadLateContent && <Suspense fallback={<div className="min-h-px" aria-hidden="true" data-id="element-53" data-mp="16qdstf31f1sg" />} data-id="element-52" data-mp="16punqyyhk7vu">
          <LateContent onCta={onCta} data-id="element-54" data-mp="35u2rxizcyg8s" />
        </Suspense>}
    </>;
}